import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@upstageai/ui";

import {
  ERROR_TYPE_TO_CONTENT,
  ErrorDialogContents,
} from "../../constants/ErrorMessage";
import { Icon, Icons } from "../Icon";

interface ErrorDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  errorType: number;
  errorCloseFunction?: () => void;
  errorReloadFunction?: () => void;
}
export default function ErrorDialog({
  open,
  setOpen,
  errorType,
  errorCloseFunction,
  errorReloadFunction,
}: ErrorDialogProps) {
  const { message, texts, buttonLeft, buttonRight } = ERROR_TYPE_TO_CONTENT.get(
    errorType,
  ) as ErrorDialogContents;

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogContent>
        <DialogHeader>
          <Icon source={Icons.Alert} className="h-[44px] w-[44px]" />
          <DialogTitle key="error-message">{message}</DialogTitle>
          <DialogDescription>
            {texts.map((text, idx) => {
              return (
                <span
                  className="pb-1 text-muted-darker"
                  key={`error-text${idx}`}
                >
                  {text}
                </span>
              );
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {buttonLeft && (
            <Button variant="outline" onClick={errorCloseFunction}>
              {buttonLeft}
            </Button>
          )}
          {buttonRight && (
            <Button onClick={errorReloadFunction}>{buttonRight}</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
